export default __webpack_public_path__ + "static/media/bg.ee7af42a.png";